var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c(
      "div",
      { staticClass: "service-box service-con1" },
      [
        _c("service-tabbar", { attrs: { returnService: _vm.returnService } }),
        _vm._m(0)
      ],
      1
    ),
    _vm._m(1),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con" }, [
      _c("h1", { staticClass: "service-title" }, [
        _vm._v(
          "\n        同司法机构系统底层打通，确保电子数据成为 “ 有效的电子证据 ”\n      "
        )
      ]),
      _c("p", { staticClass: "service-desc" }, [
        _vm._v(
          "\n        邀请权威司法机构加入保全链节点，若遇纠纷，存证的电子数据不用任何附加说明，“\n        公证处 ” “ 仲裁委 ” “ 互联网法院 ”等司法机构直接采信\n      "
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/judicialService/img1.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-box service-con2" }, [
      _c("h1", { staticClass: "service-title" }, [
        _vm._v("足不出户，证书邮寄到家")
      ]),
      _c("p", { staticClass: "service-desc" }, [
        _vm._v(
          "\n      为司法审判提供多种电子证据，支持三家以上司法机构在线申请出证\n    "
        )
      ]),
      _c("div", { staticClass: "service-con2-list" }, [
        _c("div", { staticClass: "item" }, [
          _c("h3", { staticClass: "title" }, [_vm._v("公证书")]),
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img2-1.png" }
          }),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          公证书，是指公证处根据当事人申请，依照事实和法律，按照法定程序制作的具有特殊法律效力的司法证明书，可作为呈堂证据。\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("h3", { staticClass: "title" }, [_vm._v("E证据")]),
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img2-2.png" }
          }),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          E证据，是一整套证明材料的总称，有电子版和纸质版两种可供选择，可在司法纠纷中作为证据，提交给法律机关，增加审判胜算。\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("h3", { staticClass: "title" }, [_vm._v("保管函")]),
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img2-3.png" }
          }),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          用 君子签签署的每一份文件，文件实时同步存证至公证处的\n          “保全链”节点，若遇纠纷，可由公证处颁发保管函，作为呈堂证据。\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("h3", { staticClass: "title" }, [_vm._v("电子签署技术报告")]),
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img2-4.png" }
          }),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          君子签将签署文件哈希摘要通过区块链存证，同步至相关司法机构节点，若遇纠纷，君子签可为签署方出具电子签署技术报告作为证据。\n        "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-box service-con3" }, [
      _c("h1", { staticClass: "service-title" }, [
        _vm._v("四大互联网司法通道，确保文件签署无忧")
      ]),
      _c("p", { staticClass: "service-desc" }, [
        _vm._v(
          "\n      与仲裁委、互联网法院等多个司法通道对接，实现电子数据实时存储，不被篡改，提升争议解决效率\n    "
        )
      ]),
      _c("div", { staticClass: "service-con3-list" }, [
        _c("div", { staticClass: "item" }, [
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img3-1.png" }
          }),
          _c("h3", { staticClass: "title" }, [_vm._v("代理维权")]),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          遭遇纠纷，需要追回损失，又不想自己麻烦，可以把案件委托给我们\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img3-2.png" }
          }),
          _c("h3", { staticClass: "title" }, [_vm._v("在线智能仲裁")]),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          前置拟定仲裁模板，违约后存证证据通过系统直达仲裁委，完成快速下裁\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img3-3.png" }
          }),
          _c("h3", { staticClass: "title" }, [_vm._v("网络赋强公证")]),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          依托于电子签署，签署贸易协议时同步申请赋强公证，一旦违约可在线申请执行\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "item" }, [
          _c("img", {
            staticClass: "img",
            attrs: { src: "/images/judicialService/img3-4.png" }
          }),
          _c("h3", { staticClass: "title" }, [_vm._v("互联网法院")]),
          _c("p", { staticClass: "desc" }, [
            _vm._v("存证证据同步法院司法区块链，互联网法院交案直接调用")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2b5440a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b5440a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/judicialService/introduce.vue
// module id = enPz
// module chunks = 180